export const environment = {
    production: false,
    apiUrl: 'https://api.one1-ibms-test.co.il/clientservice',
    otpResendCooldownSeconds: 30,
    superAdminCompanyId: 'ef0e12b3-a5e6-4890-ab78-4010fa40e678',
};
